import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  jwt = '';

  constructor() {}

  isJWTValid(jwt)
  {
    if (!jwt) {
      return false;
    }

    const base64Url = jwt.split('.')[1];
    const exp = JSON.parse(window.atob(base64Url)).exp;

    if (Date.now() <= exp * 1000)
    {
      this.jwt = jwt;
      return true;
    }

    return false;
  }

  getJWT()
  {
    return this.jwt;
  }

  getOperatorName()
  {
    if (!this.jwt)
    {
      return null;
    }

    const base64Url = this.jwt.split('.')[1];
    const opr = JSON.parse(window.atob(base64Url)).opr;

    return opr;
  }
}
